import { PropertyConverter } from 'angular2-jsonapi'

import { CodigoDeChamada } from '../codigo-de-chamada.model'

export class CodigoDeChamadaConverter implements PropertyConverter {
    static toModel(obj: any): CodigoDeChamada {
        if (obj instanceof CodigoDeChamada) {
            return obj
        }

        const model = new CodigoDeChamada()

        model.nomeDaOperadora = obj.nomeDaOperadora
        model.bandeira = obj.bandeira
        model.vendaCredito = obj.vendaCredito
        model.vendaDebito = obj.vendaDebito

        model.recebimentoLiquidoCredito = obj.recebimentoLiquidoCredito
        model.recebimentoLiquidoDebito = obj.recebimentoLiquidoDebito
        model.taxaOperadoraCredito = obj.taxaOperadoraCredito
        model.taxaOperadoraDebito = obj.taxaOperadoraDebito
        model.estornoDeVendasCredito = obj.estornoDeVendasCredito
        model.estornoDeVendasDebito = obj.estornoDeVendasDebito
        model.antecipacaoTaxa = obj.antecipacaoTaxa
        model.aluguel = obj.aluguel
        model.outrosAjustes = obj.outrosAjustes

        return model
    }

    static toJSON(model: CodigoDeChamada) {
        const json: any = Object.assign({}, model)

        return json
    }

    mask(value: any) {
        return CodigoDeChamadaConverter.toModel(value)
    }

    unmask(value: any) {
        return CodigoDeChamadaConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/converters/codigo-de-chamada.converter.ts